let fundingInitialized = false;

export function initFunding() {
    if (fundingInitialized) return;
    fundingInitialized = true;

    document.addEventListener("click", function (e) {
        const target = e.target;

        if (target.closest(".fundingLabel")) {
            const label = target.closest(".fundingLabel");
            const spoiler = label.nextElementSibling;
            if (spoiler && spoiler.classList.contains("fundingContent")) {
                const isVisible = spoiler.style.display !== "none";
                spoiler.style.display = isVisible ? "none" : "";
                const icon = label.querySelector("i[class*=icon-angle]");
                if (icon) {
                    icon.classList.toggle("icon-angle-down", isVisible);
                    icon.classList.toggle("icon-angle-up", !isVisible);
                }
            }
            e.preventDefault();
        }
    });
}